import React, { FC, ReactNode } from 'react';
import {Dialog, styled} from '@mui/material';

import './CustomChartPopup.css';


interface ICustomChartPopupProps {
    chartClassName ?: string;
    show: boolean,
    // eslint-disable-next-line @typescript-eslint/ban-types
    handleClose?: Function,
    children?: ReactNode;
}


const CustomizedChartPopup = styled(Dialog)(({ theme }) => (
    {
    '& .MuiDialog-root': {
      ...theme,
      padding:0
    },
  }));


const CustomChartPopup:FC<ICustomChartPopupProps> = (props) => {

    const {chartClassName,show,handleClose} = props;

    return (
        <CustomizedChartPopup
            className={'custom__chartPopup ' + chartClassName}
            open={show}
            onClick={(e) => handleClose?.(e)}
        >
            {props.children}
        </CustomizedChartPopup>
    );
}

export default CustomChartPopup;
